import { useMemo, useState } from 'react';
import { useData } from '../AdoptionData.jsx';
import { aggregate, distinctPrompts, avgWowRetention } from '../../../../lib/adoptionAnalytics.js';
import { sum } from '../util.js';
import { LoyaltyChart, UsageChart } from '../charts.jsx';
import { Kpi, Kpis } from '../Kpi.jsx';

export default function Overview() {
  const { events, aliases } = useData();
  const [mode, setMode] = useState('company');
  const [minQ, setMinQ] = useState(0);
  const agg = useMemo(() => aggregate(events, { aliases }), [events, aliases]);
  const usageAgg = useMemo(() => aggregate(events, { aliases, minQueriesPerDay: minQ }), [events, aliases, minQ]);
  const prompts = useMemo(() => distinctPrompts(events, aliases), [events, aliases]);

  if (!agg.weeks.length) return <div className="status">No external prompts in this snapshot.</div>;

  return (
    <>
      <h1>Overview</h1>
      <Kpis>
        <Kpi v={prompts.length} l="Distinct prompts" />
        <Kpi v={agg.users.length} l="External users" />
        <Kpi v={agg.companies.length} l="Companies" />
        <Kpi v={sum(agg.totalUserDays)} l="Active user-days" />
        <Kpi v={`${Math.round(avgWowRetention(agg) * 100)}%`} l="Avg WoW retention" />
        <Kpi v={`${agg.dateRange[0]} → ${agg.dateRange[1]}`} l="Date range" small />
      </Kpis>

      <section className="card">
        <h2>Loyalty — New vs Returning Users (week over week)</h2>
        <p className="desc">Active users per week split into new (first ever active) and returning. Green line = % of last week's active users back this week.</p>
        <LoyaltyChart agg={agg} />
        <div className="legend">
          <span className="leg"><span className="sw" style={{ background: '#5b8def' }} />Returning</span>
          <span className="leg"><span className="sw" style={{ background: '#f5a623' }} />New</span>
          <span className="leg"><span className="sw" style={{ background: '#37c98b' }} />WoW retention %</span>
        </div>
      </section>

      <section className="card">
        <div className="card-head">
          <h2>Usage — Weekly Active Days</h2>
          <div className="card-controls">
            <label className="thresh">Count days with &gt;
              <input type="number" min="0" max="50" value={minQ}
                onChange={(e) => setMinQ(Math.max(0, parseInt(e.target.value, 10) || 0))} /> queries
            </label>
            <div className="toggle">
              <button className={mode === 'company' ? 'on' : ''} onClick={() => setMode('company')}>By company</button>
              <button className={mode === 'total' ? 'on' : ''} onClick={() => setMode('total')}>Total trend</button>
            </div>
          </div>
        </div>
        <p className="desc">Usage = distinct active days per week (days a user ran &gt; {minQ} {minQ === 1 ? 'query' : 'queries'}). Raise the threshold to see only heavier-usage days.</p>
        <UsageChart agg={usageAgg} mode={mode} />
      </section>
    </>
  );
}
